import { categories } from "@/mocks/categories";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="bg-secondary-800/50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-grid-line text-xl text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                  Kakobuy Spreadsheet
                </span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                Najlepszy Kakobuy Spreadsheet dla polskich użytkowników. Znajdź najlepsze produkty z Chin w jednym
                miejscu — buty, ubrania, elektronika i akcesoria.
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
                  Kategorie
                </h4>
                <ul className="flex flex-col gap-2">
                  {categories.slice(0, 7).map((cat) => (
                    <li key={cat.id}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {cat.namePl}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
                  Więcej kategorii
                </h4>
                <ul className="flex flex-col gap-2">
                  {categories.slice(7).map((cat) => (
                    <li key={cat.id}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {cat.namePl}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
                  Nawigacja
                </h4>
                <ul className="flex flex-col gap-2">
                  <li>
                    <a href="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
                      Strona główna
                    </a>
                  </li>
                  <li>
                    <a href="/poradnik-zakupowy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/poradnik-zakupowy"); }}>
                      Poradnik zakupowy
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/co-to-jest-kakobuy-spreadsheet" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/co-to-jest-kakobuy-spreadsheet"); }}>
                      Co to jest Kakobuy?
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/czy-kakobuy-jest-bezpieczny" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/czy-kakobuy-jest-bezpieczny"); }}>
                      Bezpieczeństwo
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/koszty-wysylki-kakobuy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/koszty-wysylki-kakobuy"); }}>
                      Koszty wysyłki
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
                  Popularne artykuły
                </h4>
                <ul className="flex flex-col gap-2">
                  <li>
                    <a href="/artykul/kakobuy-vs-pandabuy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/kakobuy-vs-pandabuy"); }}>
                      Kakobuy vs Pandabuy
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/poradnik-poczatkujacego-kakobuy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/poradnik-poczatkujacego-kakobuy"); }}>
                      Poradnik początkującego
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/najlepsze-produkty-kakobuy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/najlepsze-produkty-kakobuy"); }}>
                      Najlepsze produkty
                    </a>
                  </li>
                  <li>
                    <a href="/artykul/opinie-uzytkownikow-kakobuy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/artykul/opinie-uzytkownikow-kakobuy"); }}>
                      Opinie użytkowników
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">Polityka prywatności</span>
            <span className="text-xs text-secondary-500">|</span>
            <span className="text-xs text-secondary-400 whitespace-nowrap">Cookies</span>
            <span className="text-xs text-secondary-500">|</span>
            <span className="text-xs text-secondary-400 whitespace-nowrap">Regulamin</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-facebook-fill text-sm text-secondary-400 hover:text-background-50 transition-colors"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-instagram-line text-sm text-secondary-400 hover:text-background-50 transition-colors"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}